/* eslint max-len: 0 */
export const messages = {
  page: {
    title: {
      id: 'healthSummary.Page.Title',
      defaultMessage: 'Health Information Summary',
    },
    introduction: {
      id: 'healthSummary.Page.Introduction',
      defaultMessage: 'Below is your recent Health Information Summary.  Use the Options button to choose a summary for a different period of time.  You can also send a copy to someone, or download a copy as a file.',
    },
    noHealthSummary: {
      id: 'healthSummary.Page.NoHealthSummary',
      defaultMessage: 'No Health Information Summary is available.',
    },
    multipleExternalSystems: {
      id: 'healthSummary.Page.MultipleExternalSystems',
      defaultMessage: 'Your Health Information is in more than one system. Go to Options to select the system.',
    },
    download: {
      id: 'healthSummary.Page.Download',
      defaultMessage: 'Download',
    },
    sendByEmail: {
      id: 'healthSummary.Page.SendByEmail',
      defaultMessage: 'Send by Email',
    },
    sendSecurely: {
      id: 'healthSummary.Page.SendSecurely',
      defaultMessage: 'Send Securely',
    },
    options: {
      id: 'healthSummary.Page.Options',
      defaultMessage: 'Options',
    },
    downloadMessage: {
      id: 'healthSummary.Page.DownloadMessage',
      defaultMessage: 'Downloads the Health Summary File.',
    },
    ccdaLabel: {
      id: 'healthSummary.Page.CcdaLabel',
      defaultMessage: 'CCDA',
    },
  },
  datelist: {
    title: {
      id: 'healthSummary.Datelist.Title',
      defaultMessage: 'There is more than one health summary within that date range. Please select one.',
    },
    tableheader: {
      id: 'healthSummary.Datelist.Tableheader',
      defaultMessage: 'Health Information Summary dates',
    },
    viewlabel: {
      id: 'healthSummary.Datelist.Viewlabel',
      defaultMessage: 'View',
    },
    cancellabel: {
      id: 'healthSummary.Datelist.Cancellabel',
      defaultMessage: 'Cancel',
    },
  },
};
